import React from "react";
import {createRoot} from 'react-dom/client'
import {BrowserRouter} from "react-router";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {Analytics} from "./analytics/analytics.ts";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";

import App from './App.jsx'
import MaintenancePage from "./components/MaintenancePage";
import './index.css'

const queryClient = new QueryClient();

const MAINTENANCE = import.meta.env.VITE_MAINTENANCE_MODE === "true";

createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        {MAINTENANCE ? (
            <MaintenancePage/>
        ) : (
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <Analytics/>
                    <App/>
                </BrowserRouter>
            </QueryClientProvider>
        )}
    </React.StrictMode>
)
